/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './viewer-preview-root.html';

import config from '../../../config';
import { $root } from '../../../player/player';
import { mixinType } from '../../../util.type';
import ContentOverlayContainer from '../../content/overlay/content-overlay-container';
import LoaderRoot from '../../loader/loader-root';
import ProgressBar from '../../progress-bar/progress-bar';
import PromiseUtil from '../../promise/promise-util';

/**
 * @import { ContentInfo } from '../../content/info/content-info'
 */
const toastMessageTimeout = 2 * 1000;
const tryAgainTimeout = 500;

export default defineComponent({
  name: 'ViewerPreviewRoot',
  template,
  components: { ContentOverlayContainer, LoaderRoot, ProgressBar },
  created() {
    // Naslouchání událostem.
    $root(this).device.on('content', this.onContent);
    this.fileSystemAccessApi =
      $root(this).browserCapabilities.fileSystemAccessApi();
    $root(this).playbackControlsEmitter.on('stop', this.onStop);
  },
  mounted() {
    const previewRootEl = document.getElementById('preview-root');
    if (previewRootEl === null) {
      throw new Error('missing preview-root element');
    }
    this.previewRootEl = previewRootEl;
    this.onStop = this.onStop.bind(this);
  },
  data() {
    return mixinType(
      {
        /** @type {ContentInfo | null} */
        contentInfo: null,
        /** @type {Error | undefined} */
        error: undefined,
        fetching: false,
        /** @type {string | undefined} */
        popupText: undefined,
        started: false
      },
      /**
       * @type {{
       *   fileSystemAccessApi: boolean;
       *   previewRootEl: HTMLElement;
       * }}
       */
      ({})
    );
  },
  destroyed() {
    // Zrušení naslouchání událostem.
    $root(this).device.off('content', this.onContent);
  },
  emits: {},
  methods: {
    onStop() {
      $root(this).device.destroy();
      this.error = undefined;
      this.started = false;
      this.contentInfo = null;
    },
    closePreview() {
      window.close();
    },
    copyError() {
      if (!this.error) {
        return;
      }
      const { message } = this.error;
      this.popupText = 'Error message copied.';
      navigator.clipboard.writeText(`Error: ${message}`);
      setTimeout(() => {
        this.popupText = undefined;
      }, toastMessageTimeout);
    },
    /**
     * @param {ContentInfo} contentInfo
     */
    onContent(contentInfo) {
      this.contentInfo = contentInfo;
    },
    playPreview() {
      this.started = true;
      this.fetching = true;
      // Na výsledek není potřeba čekat.
      $root(this)
        .deviceStart(null, this.previewRootEl)
        .then(() =>
          setTimeout(() => this.onStop(), config.device.preview.timeout)
        )
        .catch((/** @type {Error} */ err) => {
          this.error = err;
          $root(this).device.destroy();
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    async tryAgain() {
      this.error = undefined;
      await PromiseUtil.wait(tryAgainTimeout);
      this.playPreview();
    }
  },
  props: {
    className: { type: String, required: true }
  }
});
